import template from './office.html';
import controller from './office.controller';
import './office.scss';

let officeComponent = {
  restrict: 'E',
  bindings: {selectedOffice: '<'},
  template,
  controller
};

export default officeComponent;



// WEBPACK FOOTER //
// ./client/app/components/offices/office/office.component.js